import {Sort} from "./Sort";
import {FilterGroup} from "./FilterGroup";
import {Filter} from "./Filter";

export class PagingRequest {

  page?: number;
  pageSize?: number;
  sorts: Array<Sort> = [];
  filters: Array<Filter> = [] ;
  filterGroups: Array<FilterGroup> = [];
  distinct?: boolean = undefined;

  static clone(pagingRequest: PagingRequest): PagingRequest {
    const newPagingRequest = new PagingRequest();
    newPagingRequest.pageSize = pagingRequest.pageSize;
    newPagingRequest.page = pagingRequest.page;
    newPagingRequest.sorts = pagingRequest.sorts;
    newPagingRequest.filters = [...(pagingRequest.filters || [])];
    newPagingRequest.filterGroups = [...(pagingRequest.filterGroups || [])];
    newPagingRequest.distinct = pagingRequest.distinct;

    return newPagingRequest;
  }
}
